"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Bool = ({
  value
}) => {
  return /*#__PURE__*/_react.default.createElement("span", null, value === undefined ? '' : value === true ? 'Yes' : 'No');
};
Bool.propTypes = process.env.NODE_ENV !== "production" ? {
  value: _propTypes.default.bool,
  schema: _propTypes.default.object
} : {};
var _default = exports.default = Bool;
module.exports = exports.default;